const e = {
  placement: "right",
  triggerByHover: !0,
  offsetDistance: 6,
  arrow: !0,
  openDelay: 100,
  toggleByClick: !1,
  disabled: !1
}, t = 40;
export {
  t as DEFAULT_LIST_ITEM_HEIGHT,
  e as DEFAULT_LIST_POPPER
};
//# sourceMappingURL=list.js.map
